import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  SellarImportsPayoutCreateRequestType,
  SellarImportsPayoutCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useSellarImportPayoutCreate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SellarImportsPayoutCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `sellar-imports/finance/payouts`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SellarImportsPayoutCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
        ],
      });
    },
  });
};
